import { CMS_ELEMENT_TYPENAME } from "@repo/utils/constants"
// import {mergeQueriesArray} from "@repo/utils";

function mergeQueriesArray(queriesArray = [""]) {
	if (queriesArray.length <= 0) return ""
	return queriesArray.reduce((prevString, link) => {
		if (!link) return prevString
		return `${prevString}
                ${link}`
	}, "")
}

const SEO_META_FRAGMENT = `
	_seoMetaTags {
		content
		tag
		attributes
	}
`

const PADDINGS_FRAGMENT = `
	paddings {
		top
		bottom
	}
`

const COLOR_SCHEME_FRAGMENT = `
	colorScheme {
	    colorScheme
	}
`

const IMAGE_FRAGMENT = `
    ${CMS_ELEMENT_TYPENAME}
	id
	url
	alt
	width
	height
	focalPoint{
	  x
	  y
	}
	blurUpThumb
	mimeType
`

const VIDEO_FRAGMENT = `
    ${CMS_ELEMENT_TYPENAME}
	id
	url
	alt
	width
	height
	mimeType
`

const THEME_FRAGMENT = `
    themeLight {
        mainPrimary {
            hex
        }
        mainSecondary {
            hex
        }
        mainTertiary {
            hex
        }
        extraPrimary {
            hex
        }
        extraSecondary {
            hex
        }
        extraTertiary {
            hex
        }
    }
    themeDark {
        mainPrimary {
            hex
        }
        mainSecondary {
            hex
        }
        mainTertiary {
            hex
        }
        extraPrimary {
            hex
        }
        extraSecondary {
            hex
        }
        extraTertiary {
            hex
        }
    }
`
const TEXT_WITH_BREAKS_FRAGMENT = `
    id
    text {
      text
      breaks{
        id
        image {
          ${IMAGE_FRAGMENT}
        }
      }
    }
`

const LINK_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
         link {
            ${mergeQueriesArray(links)}
         }
    `
}

const LINK_BUTTON_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
        button {
            text
            variant
             ${LINK_FRAGMENT_FUNCTION(links)}
        }
    `
}

const STORY_TEXT_WITH_BREAKS_FRAGMENT_FUNCTION = (links = [""]) => {
	return `
    id
   ${LINK_FRAGMENT_FUNCTION(links)}
    text {
      text
      breaks{
        id
        image {
          ${IMAGE_FRAGMENT}
        }
      }
    }
`
}

export default {
	SEO_META_FRAGMENT,
	IMAGE_FRAGMENT,
	THEME_FRAGMENT,
	TEXT_WITH_BREAKS_FRAGMENT,
	STORY_TEXT_WITH_BREAKS_FRAGMENT_FUNCTION,
	PADDINGS_FRAGMENT,
	COLOR_SCHEME_FRAGMENT,
	LINK_FRAGMENT_FUNCTION,
	LINK_BUTTON_FRAGMENT_FUNCTION,
	VIDEO_FRAGMENT,
}
